import { supabase } from '@/lib/supabase'

export async function signInWithPassword(email: string, password: string) {
  return supabase.auth.signInWithPassword({ email, password })
}

export async function signOut() {
  return supabase.auth.signOut()
}

export async function isAffiliateAllowed(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('affiliates')
      .select('active')
      .eq('user_id', userId)
      .maybeSingle()
    if (error) return true
    return (data?.active ?? true) !== false
  } catch {
    return true
  }
}
